import { Fragment, useState } from "react";
import CalendarYearSelect from "./CalendarYearSelect";
import CalendarMonthSelect from "./CalendarMonthSelect";
import { Button } from "react-bootstrap";

const CalendarHeader = ({
  calendarRef,
  addEvent,
  dateValues,
  handleCalendarChange,
}) => {
  let calendarApi = calendarRef.current.getApi();
  const [title, setTitle] = useState(calendarApi.view.title);

  const getDateMonth = () => {
    var date = calendarApi.getDate();
    return date.getMonth() + 1;
  };
  const getDateYear = () => {
    var date = calendarApi.getDate();
    return date.getFullYear();
  };

  const changeCalendarDate = (year = getDateYear(), month = getDateMonth()) => {
    calendarApi.gotoDate(new Date(year, month - 1, 1));
    handleCalendarChange(year, month);
    setTitle(calendarApi.view.title);
  };

  const refreshCalendar = () => {
    handleCalendarChange(getDateYear(), getDateMonth());
    calendarApi.render();
  };
  const nextHandle = () => {
    calendarApi.next();
    handleCalendarChange(getDateYear(), getDateMonth());
    setTitle(calendarApi.view.title);
  };
  const prevHandle = () => {
    calendarApi.prev();
    handleCalendarChange(getDateYear(), getDateMonth());
    setTitle(calendarApi.view.title);
  };

  return (
    <Fragment>
      <div className="calendar-app-header row">
        <div className="col date-picker">
          <CalendarYearSelect
            dateValues={dateValues}
            changeCalendarDate={changeCalendarDate}
          />
          <CalendarMonthSelect
            dateValues={dateValues}
            changeCalendarDate={changeCalendarDate}
            getDateYear={getDateYear}
            allYear={false}
          />
        </div>
        <div className="col date-title">
          <Button variant="outline-dark" onClick={prevHandle}>
            <i className="bi bi-arrow-left"></i>
          </Button>
          <h2>{title}</h2>
          <Button variant="outline-dark" onClick={nextHandle}>
            <i className="bi bi-arrow-right"></i>
          </Button>
        </div>
        <div className="col add-event-btn gap-2">
          <Button variant="outline-secondary" onClick={refreshCalendar}>
            <i className="bi bi-arrow-clockwise" />
          </Button>
          <Button variant="primary" onClick={() => addEvent()}>
            Agregar Cita
            <i className="bi bi-calendar2-plus ms-2"></i>
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

export default CalendarHeader;
